import { useContext } from "react";
import { LobbySettingsContext } from "../../../entities/lobby";

export function useLobbyLogo() {
  return useContext(LobbySettingsContext).Logo;
}
